export default class CookieWidget {
  // Статические константы для стилей и контента по умолчанию
  static DEFAULT_STYLES = `


/* Основные стили виджета */
:root {
    --ct-pink: #e5006a
}

.cookie-widget,
.cookie-widget * {
    box-sizing: border-box !important
}

.cookie-widget {
    color: #111
}

/* Стили для переключателя (скрыт) */
input#cookie-toggle {
    position: fixed;
    bottom: 0;
    left: -10000px;
    visibility: hidden
}

/* Анимации скрытия/показа */
#cookie-toggle:checked~.cookie-widget,
.cookie-widget.not-ready {
    opacity: 0;
    visibility: hidden;
    transform: translate(50%, calc(100% + 32px));
    transition: visibility .25s ease-in .5s, opacity .25s ease-in .5s, transform .75s cubic-bezier(.68, -.55, .27, 1.55) 0s
}

.cookie-widget {
    z-index: 999;
    border-radius: 0;
    box-sizing: border-box;
    padding: 20px;
    position: fixed;
    right: 50%;
    bottom: 0;
    width: 100%;
    max-width: 1200px;
    box-shadow: 0 3px 12px #0000003F;
    opacity: 1;
    overflow: hidden;
    transition: visibility .25s ease-in, opacity .25s ease-in,
        transform .75s cubic-bezier(.68, -.55, .27, 1.55) .25s;
    transform: translate(50%, 0);
    visibility: visible;
    text-align: center;
    border-radius: 0;
}

/* Фон с эффектом размытия */
.cookie-widget:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 250%;
    height: 100%;
    background-color: #FFFFFFdd;
    backdrop-filter: blur(6px) saturate(2) contrast(2)
}

/* Стили контента */
.cookie-content {
    position: relative;
    z-index: 10;
    text-align: left;
    padding: 0 96px 0 0;
}

.cookie-content h3 {
    font-weight: 600;
    line-height: 1em;
    font-size: 28px;
    padding: 0;
    margin: 0 auto 1rem;
    color: var(--ct-pink);
    text-align: center;
    display: none;
}

.cookie-widget.is-mzk h3,
.cookie-widget.is-mzk a {
    color: #ffa
}

.cookie-content p {
    font-size: 14px;
    line-height: 1.3em;
    font-weight: 400;
    margin: 1em 0
}

.cookie-content a {
    font-weight: 600;
    text-decoration: none;
    color: var(--ct-pink);
    border-bottom: 1px solid;
    display: inline-block;
    transition: all .25s ease-in-out;
    padding: 0 .25em
}

.cookie-content a:hover {
    box-shadow: 0 -32px var(--ct-pink) inset;
    color: #fff
}

/* Стили кнопки */
.cookie-content fieldset {
    display: block;
    text-align: center;
    padding: 0;
    border: 0 none;
    margin: 0;
    position: absolute;
    right: 0;
    top: 0;
    top: 50%;
    transform: translate(0,-50%);
}

.cookie-content fieldset .btn {
    background: var(--ct-pink);
    color: #fff;
    font-size: 16px;
    padding: 8px 24px;
    border-radius: 3px;
    margin: .5rem auto 0;
    border: 0 none;
    display: inline-block;
    cursor: pointer;
    transition: all .2s ease-out;
    box-shadow: 0 3px 6px #0000003F;
    text-transform: uppercase;
    font-weight: 600;
    font-family: TTNorms, sans-serif
}

.cookie-content fieldset .btn:hover {
    box-shadow: 0 3px 24px #00000026;
    color: var(--ct-pink);
    background: #000
}

/* Темные темы */
.cookie-widget.is-dark,
.cookie-widget.is-mzk {
    box-shadow: 0 3px 64px #FFFFFF3F;
    color: #fff
}

.cookie-widget.is-mzk:before {
    background-image: linear-gradient(35deg, #ef5958 0, #f7962d 50%, #ef5958 100%)
}

.cookie-widget.is-dark:before {
    background-color: #000000A5
}

.is-dark .cookie-content fieldset .btn:hover,
.is-mzk .cookie-content fieldset .btn:hover {
    background-color: #fff
}

/* Анимации появления/исчезновения */
.cookie-widget.cookie-widget-enter {
    opacity: 0;
    transform: translate(50%, 20px)
}

.cookie-widget.cookie-widget-enter-active {
    opacity: 1;
    transform: translate(50%, 0);
    transition: opacity 0.5s ease-out, transform 0.5s ease-out
}

.cookie-widget.cookie-widget-exit {
    opacity: 1;
    transform: translate(50%, 0)
}

.cookie-widget.cookie-widget-exit-active {
    opacity: 0;
    transform: translate(50%, 20px);
    transition: opacity 0.5s ease-in, transform 0.5s ease-in
}

/* Мобильная версия */
@media (max-width:640px) {
    .cookie-widget {
        right: 50%;
        bottom: 0;
        width: 100%;
        max-width: 100vw;
        padding: 32px 16px;
        transform: translate(50%, 0);
        font-size: 11px
    }

    .cookie-widget .cookie-content p {
        font-size: 12px
    }

    .cookie-widget .cookie-content h3 {
        font-size: 16px
    }
}
  
  
  
  `;

  // HTML-контент по умолчанию
  static DEFAULT_CONTENT = `
<h3>Мы используем cookie</h3><p><a target="_blank" href="https://digitalrussia.tv">АО «ЦТВ»</a> использует <a target="_blank" href="https://digitalrussia.tv/dtr_cookie_policy.pdf">cookie-файлы</a> и обрабатывает <a target="_blank" href="https://digitalrussia.tv/dtr_personal_data_processing_policy.pdf">персональные данные</a> для улучшения работы сайта. Подтвердите ваше согласие, нажав кнопку</p>
<fieldset class="acceptPolicy"><button class="btn" id="cookieSwitch">OK</button></fieldset>
  `;

  constructor(options = {}) {
    // Инициализация настроек с дефолтными значениями
    this.options = {
      cookieName: 'CTwgt',         // Имя cookie
      cookieExpiryHrs: 48,         // Время жизни cookie в часах
      cookieTheme: '',              // Тема виджета
      cookieHTML: null,             // Кастомный HTML
      cookieScroll: null,           // Триггер по скроллу
      ...options                    // Переопределение пользовательскими настройками
    };
    
    // DOM-элементы
    this.widget = null;
    this.toggleButton = null;
    this.toggleCheckbox = null;
    
    // Обработчики
    this.scrollHandler = null;
    this.isInitialized = false;

    // Инициализация менеджера cookie
    this.initCookieManager();

    // Проверяем согласие пользователя перед инициализацией
    if (!this.hasConsent()) {
      this.init();
    } else {
      document.body.classList.add('CTwgt');
    }
  }

  /**
   * Основной метод инициализации виджета
   */
  async init() {
    if (this.isInitialized) return;

    try {
      // Добавляем стили
      await this.addStyles();

      // Если задан триггер по скроллу - настраиваем его
      if (this.options.cookieScroll) {
        this.setupScrollTrigger();
      } else {
        // Иначе полная инициализация
        await this.fullInitialization();
      }

      this.isInitialized = true;
    } catch (error) {
      console.error('CookieWidget initialization error:', error);
    }
  }

  /**
   * Настройка триггера по скроллу страницы
   */
  setupScrollTrigger() {
    // Функция для дебаунсинга (устранения частых вызовов)
    const debounce = (func, wait = 100) => {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    };

    // Обработчик скролла с дебаунсингом
    this.scrollHandler = debounce(() => {
      if (window.scrollY >= this.options.cookieScroll) {
        this.fullInitialization();
        window.removeEventListener('scroll', this.scrollHandler);
      }
    });

    // Добавляем обработчик
    window.addEventListener('scroll', this.scrollHandler);
    // Вызываем сразу на случай если пользователь уже проскроллил
    this.scrollHandler();
  }

  /**
   * Полная инициализация виджета (добавление HTML и настройка)
   */
  async fullInitialization() {
    try {
      await this.addHtml();
      await this.setupWidget();
    } catch (error) {
      console.error('CookieWidget full initialization error:', error);
    }
  }

  /**
   * Инициализация менеджера cookie (методы для работы с cookie)
   */
  initCookieManager() {
    this.cookieManager = {
      // Установка cookie
      set: (key, value, hours, path = '/', secure = false) => {
        const expires = new Date();
        expires.setTime(expires.getTime() + (hours * 60 * 60 * 1000));
        document.cookie = `${key}=${value}; path=${path}; expires=${expires.toUTCString()}${secure ? '; secure' : ''}`;
      },

      // Получение значения cookie
      get: (key) => {
        const keyValue = document.cookie.match(`(^|;) ?${key}=([^;]*)(;|$)`);
        return keyValue ? keyValue[2] : null;
      },

      // Удаление cookie
      remove: (key, path = '/') => {
        document.cookie = `${key}=; Max-Age=0; path=${path}`;
      }
    };
  }

  /**
   * Добавление стилей виджета в head документа
   */
  async addStyles() {
    return new Promise((resolve) => {
      // Если стили уже добавлены - выходим
      if (document.querySelector('style[data-cookie-widget]')) {
        return resolve();
      }

      // Создаем элемент style и добавляем в head
      const style = document.createElement('style');
      style.setAttribute('data-cookie-widget', '');
      style.textContent = CookieWidget.DEFAULT_STYLES;
      document.head.appendChild(style);
      resolve();
    });
  }

  /**
   * Добавление HTML виджета в конец body
   */
  async addHtml() {
    return new Promise((resolve) => {
      // Если виджет уже есть - выходим
      if (document.getElementById('acceptCookies')) {
        return resolve();
      }

      // Используем кастомный HTML или дефолтный
      const content = this.options.cookieHTML || CookieWidget.DEFAULT_CONTENT;

      // Генерируем HTML
      const html = `
        <input type="checkbox" name="cookie-toggle" id="cookie-toggle" />
        <div class="cookie-widget not-ready ${this.options.cookieTheme}" id="acceptCookies">
          <div class="cookie-content">
            ${content}
          </div>
        </div>
      `;

      // Добавляем в конец body
      document.body.insertAdjacentHTML('beforeend', html);
      resolve();
    });
  }

  /**
   * Настройка виджета после добавления в DOM
   */
  async setupWidget() {
    return new Promise((resolve) => {
      // Функция проверки DOM (на случай если элементы еще не загрузились)
      const checkDOM = () => {
        this.widget = document.getElementById('acceptCookies');
        this.toggleButton = document.getElementById('cookieSwitch');
        this.toggleCheckbox = document.getElementById('cookie-toggle');

        if (this.widget && this.toggleButton && this.toggleCheckbox) {
          // Анимация появления
          this.widget.classList.add('cookie-widget-enter');

          // Задержка перед началом анимации
          setTimeout(() => {
            this.widget.classList.remove('not-ready');
            this.widget.classList.add('cookie-widget-enter-active');
            this.widget.classList.remove('cookie-widget-enter');

            // Убираем классы анимации после завершения
            setTimeout(() => {
              this.widget.classList.remove('cookie-widget-enter-active');
            }, 500);
          }, 100);

          // Добавляем обработчик клика на кнопку
          this.toggleButton.addEventListener('click', () => this.handleConsent());
          resolve();
        } else {
          // Если элементы не найдены - проверяем снова через 50мс
          setTimeout(checkDOM, 50);
        }
      };

      // Запускаем проверку DOM
      if (document.readyState === 'complete') {
        checkDOM();
      } else {
        window.addEventListener('load', checkDOM);
      }
    });
  }

  /**
   * Обработчик согласия пользователя
   */
  handleConsent() {
    const hasConsent = this.hasConsent();
    this.setConsent(!hasConsent);
  }

  /**
   * Установка согласия пользователя
   * @param {boolean} given - Флаг согласия
   */
  setConsent(given) {
    if (given) {
      // Устанавливаем cookie
      this.cookieManager.set(
        this.options.cookieName,
        'true',
        this.options.cookieExpiryHrs
      );
      document.body.classList.add('CTwgt');

      // Анимация исчезновения
      this.widget.classList.add('cookie-widget-exit');
      this.widget.classList.add('cookie-widget-exit-active');

      // Добавляем not-ready после начала анимации
      setTimeout(() => {
        this.widget.classList.add('not-ready');
      }, 200);

      // Удаление виджета после анимации
      setTimeout(() => {
        this.destroy();
      }, 500);

      this.toggleCheckbox.checked = true;
    } else {
      // Удаляем cookie
      this.cookieManager.remove(this.options.cookieName);
      document.body.classList.remove('CTwgt');
      this.toggleCheckbox.checked = false;
    }
  }

  /**
   * Проверка наличия согласия пользователя
   * @returns {boolean} - Есть ли согласие
   */
  hasConsent() {
    return this.cookieManager.get(this.options.cookieName) === 'true';
  }

  /**
   * Установка темы виджета
   * @param {string} themeName - Имя темы
   */
  setTheme(themeName) {
    if (this.widget) {
      this.widget.classList.remove(this.options.cookieTheme);
      this.options.cookieTheme = themeName;
      if (themeName) {
        this.widget.classList.add(themeName);
      }
    }
  }

  /**
   * Обновление контента виджета
   * @param {string} html - Новый HTML контент
   */
  updateContent(html) {
    if (this.widget) {
      const contentContainer = this.widget.querySelector('.cookie-content');
      if (contentContainer) {
        // Сохраняем кнопку и заменяем контент
        const buttonHtml = contentContainer.querySelector('.acceptPolicy')?.outerHTML || '';
        contentContainer.innerHTML = html + buttonHtml;
        this.toggleButton = contentContainer.querySelector('#cookieSwitch');
        this.toggleButton.addEventListener('click', () => this.handleConsent());
      }
    }
  }

  /**
   * Уничтожение виджета (очистка)
   */
  destroy() {
    // Удаление DOM-элементов
    if (this.widget) {
      this.widget.remove();
      this.widget = null;
    }

    // Удаление обработчиков событий
    if (this.toggleButton) {
      this.toggleButton.removeEventListener('click', this.handleConsent);
      this.toggleButton = null;
    }

    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;
    }

    // Сброс остальных свойств
    this.toggleCheckbox = null;
    this.isInitialized = false;
  }
}